import DriveEtaOutlinedIcon from "@mui/icons-material/DriveEtaOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import APButton from "../../components/buttons/APButton";
import { filterVisibleDossiers, isDossierActive } from "../../helpers/dossiers";
import { useAuth } from "../../providers/AuthProvider";
import { Dossier } from "../../types/Dossier";
import DossierCard from "../components/DossierCard";

const DossierList = ({
  dossiers,
  onNewQuote,
  onSubmitClaim,
  canCreateDossier,
  driverPortalEnabled,
}: {
  dossiers: Dossier[];
  onNewQuote?: () => void;
  onSubmitClaim?: () => void;
  canCreateDossier?: boolean;
  driverPortalEnabled?: boolean;
}) => {
  const { inAppScope } = useAuth();
  const renderCard = (dossier: Dossier) => {
    return (
      <DossierCard
        id={dossier.id}
        key={dossier.id}
        status={dossier.status}
        identity={dossier.identity}
        startDate={dossier.startDate}
        endDate={dossier.endDate}
        vehicleMake={dossier.vehicleMakeName}
        vehicleModel={dossier.vehicleModelName}
        vehicleYear={dossier.vehicleModelyear}
        vehicleImage={dossier.vehicleVariantImage || "/photo-placeholder.png"}
        driverPortalEnabled={driverPortalEnabled}
      />
    );
  };
  const hasActiveDossier = dossiers.some(isDossierActive);
  const showSubmitClaimButton =
    hasActiveDossier && driverPortalEnabled && inAppScope("external");

  return (
    <Stack spacing={2}>
      <Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          {canCreateDossier && onNewQuote && (
            <Box>
              <Button
                size="large"
                color="secondary"
                variant="contained"
                disableElevation={true}
                startIcon={<DriveEtaOutlinedIcon />}
                onClick={onNewQuote}
              >
                New Quote
              </Button>
            </Box>
          )}
          {showSubmitClaimButton && onSubmitClaim && (
            <Box>
              <APButton
                text="Submit Claim"
                variant="contained"
                onClick={onSubmitClaim}
              />
            </Box>
          )}
        </Box>
      </Box>
      {filterVisibleDossiers(dossiers).map(renderCard)}
    </Stack>
  );
};

export default DossierList;
